/*
 * Copyright 2026 North Carolina State University
 */

// Utility functions for handling user display, including deleted users

/**
 * Get display name for a user, handling deleted users
 * @param {Object} user - User object from project
 * @returns {string} - Display name
 */
export const getUserDisplayName = (user) => {
  if (!user) return 'Unknown User';
  
  const firstName = user.first_name || '';
  const lastName = user.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim() || 'Unknown User';
  
  if (user.isDeleted === true) {
    return `${fullName} (deleted user)`;
  }
  
  return fullName;
};

/**
 * Get display email for a user, handling deleted users
 * @param {Object} user - User object from project
 * @returns {string} - Display email
 */
export const getUserDisplayEmail = (user) => {
  if (!user) return 'Unknown';
  
  if (user.isDeleted === true) {
    return `${user.email || 'Unknown'} (deleted user)`;
  }
  
  return user.email || 'Unknown';
};

/**
 * Check if a user is deleted
 * @param {Object} user - User object from project
 * @returns {boolean} - True if user is deleted
 */
export const isUserDeleted = (user) => {
  return user?.isDeleted === true;
};

/**
 * Get user status display, handling deleted users
 * @param {Object} user - User object from project
 * @returns {string} - Status display
 */
export const getUserStatusDisplay = (user) => {
  if (isUserDeleted(user)) {
    return 'Deleted';
  }
  
  return user?.status || 'Active';
};
